/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1EnvironmentState } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_ENVIRONMENT_STATE_ENTITY_NAME = 'o5.aws.deployer.v1.Environment';
export const o5AwsDeployerV1EnvironmentStateEntity = new schema.Entity<O5AwsDeployerV1EnvironmentState>(O5_AWS_DEPLOYER_V1_ENVIRONMENT_STATE_ENTITY_NAME, {}, { idAttribute: 'environmentId' });

